export const cardBaseClass = 'ui-card-';
export const stretchOnMobileClass = `${cardBaseClass}-stretched-up-to-and-including-phone-landscape`;
